import React from 'react';
import { motion } from 'framer-motion';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { FAQS, CONTACT_EMAIL } from '../../data/landingContent';
import { reveal } from './Showcase';

export const Faq = () => (
  <section id="faq" className="lp-section lp-section--paper lp-section--tight" data-testid="faq-section">
    <div className="lp-wrap lp-faq">
      <motion.div {...reveal()} className="lp-head">
        <span className="lp-eyebrow">FAQ</span>
        <h2 className="lp-h2">Questions nurses ask us.</h2>
      </motion.div>
      <Accordion type="single" collapsible className="lp-acc">
        {FAQS.map((f, i) => (
          <AccordionItem key={f.q} value={`q${i}`} className="lp-acc__item">
            <AccordionTrigger className="lp-acc__q" data-testid={`faq-question-${i + 1}`}>{f.q}</AccordionTrigger>
            <AccordionContent className="lp-acc__a" data-testid={`faq-answer-${i + 1}`}>{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

const LEGAL_LINKS = [
  ['/privacy', 'Privacy Policy'],
  ['/terms', 'Terms of Service'],
  ['/disclaimer', 'Medical Disclaimer'],
];

export const Footer = () => (
  <footer className="lp-footer" data-testid="landing-footer">
    <div className="lp-wrap lp-footer__grid">
      <div>
        <a href="/" className="lp-brand"><img src="/landing/icon.webp" alt="" width="30" height="30" /><span>ShiftReady</span></a>
        <p className="lp-footer__note">Tools for better care. ShiftReady is a personal organization tool, not a medical device.</p>
      </div>
      <nav className="lp-footer__links">
        {LEGAL_LINKS.map(([href, label]) => (
          <a key={href} href={href} data-testid={`footer-${href.slice(1)}-link`}>{label}</a>
        ))}
        <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-contact-link">{CONTACT_EMAIL}</a>
      </nav>
    </div>
    <div className="lp-wrap lp-footer__legal" data-testid="footer-copyright">
      © {new Date().getFullYear()} ShiftReady LLC, a Florida limited liability company. All rights reserved.
    </div>
  </footer>
);
